module.exports = __webpack_public_path__ + "static/media/ic-followers.6f03d8aa.svg";